import {components} from "react-select";
import React from "react";

export const CustomSelectLabel = (props) => {
    const {customLabel, value} = props.selectProps;

    const renderCustomLabel = () => {
        if (!value || !customLabel) {
            return;
        }
        return (
            <div className={'form-field-top-placeholder-wrapper'}>
                <span className={'form-field-top-placeholder'}>
                    {customLabel}
                </span>
            </div>
        );
    }

    return (
        <components.Control {...props}>
            {renderCustomLabel()}
            {props.children}
        </components.Control>
    );
};